<template>
  <v-menu
    v-model="menu"
    menu-props="offsetY"
    :nudge-bottom="35"
    max-width="600"
    min-width="600"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on: menu }">
      <ToolbarIconButton
        :tooltip="'Сортировка'"
        :icon="'sort'"
        data-test="sortButton"
        v-on="{ ...menu }"
      />
    </template>

    <v-card>
      <v-card-title class="px-3 pt-3 pb-0">
        <h2 class="title">
          Сортировка
        </h2>
      </v-card-title>
      <v-card-text>
        <v-layout>
          <v-flex xs6>
            <h3 class="subheading grey--text text--darken-1">
              Доступно
            </h3>
            <div class="list">
              <v-list>
                <v-list-tile
                  v-for="(item, name) in availableColumns"
                  :key="name"
                  @click="moveToSelectedColumns(item)"
                >
                  <v-list-tile-content>
                    <v-list-tile-title v-text="item.title" />
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </div>
          </v-flex>

          <v-divider
            vertical
            class="mx-1"
          />

          <v-flex xs6>
            <h3 class="subheading grey--text text--darken-1 pl-3">
              Выбрано
            </h3>
            <div class="list pl-3">
              <v-list>
                <v-list-tile
                  v-for="(item, name) in selectedColumns"
                  :key="name"
                  class="list-title"
                >
                  <v-list-tile-action>
                    <v-layout>
                      <v-icon
                        small
                        @click="moveUp(item)"
                      >
                        arrow_upward
                      </v-icon>
                      <v-icon
                        small
                        @click="moveDown(item)"
                      >
                        arrow_downward
                      </v-icon>
                    </v-layout>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title
                      @click="moveToAvailableColumns(item)"
                      v-text="item.title"
                    />
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn
                      small
                      icon
                      @click="changeDirection(item)"
                    >
                      <v-icon
                        small
                        color="grey darken-1"
                      >
                        {{ item.isDesc === false ? 'text_rotation_down' : 'text_rotate_up' }}
                      </v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <SaveBtn @click="apply" />
        <CancelBtn @click="menu = !menu" />
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import arrayMove from "array-move";
import ToolbarIconButton from "../ToolbarIconButton.vue";

export default {
  components: {
    ToolbarIconButton,
  },
  props: ["store", "columns"],
  data() {
    return {
      menu: false,
      selectedColumns: [],
    };
  },
  computed: {
    availableColumns() {
      return this.columns
        .filter((c) => c.sortable === true)
        .filter(
          ({ name }) => !this.selectedColumns.find((s) => s.name === name),
        )
        .map((el) => {
          return {
            name: el.name,
            title: el.title,
          };
        });
    },
    storeSort: {
      get() {
        return this.$store.getters[`${this.store}/sort`];
      },
      set() {
        return this.$store.commit(
          `${this.store}/setSort`,
          this.copyColumns(this.selectedColumns),
        );
      },
    },
  },
  watch: {
    menu(value) {
      if (value) {
        this.selectedColumns = this.copyColumns(this.storeSort);
      } else {
        this.selectedColumns = [];
      }
    },
  },
  methods: {
    copyColumns(source) {
      return source.map((s) => {
        return {
          name: s.name,
          title: s.title,
          isDesc: s.isDesc,
        };
      });
    },
    apply() {
      this.menu = false;
      this.storeSort = this.copyColumns(this.selectedColumns);

      const parsed = JSON.stringify(this.storeSort);
      localStorage.setItem("sort", parsed);
    },
    moveUp(item) {
      const from = this.selectedColumns.indexOf(item);
      this.selectedColumns = arrayMove(this.selectedColumns, from, from - 1);
    },
    moveDown(item) {
      const from = this.selectedColumns.indexOf(item);
      this.selectedColumns = arrayMove(this.selectedColumns, from, from + 1);
    },
    moveToSelectedColumns(item) {
      if (!item) {
        return;
      }
      this.selectedColumns.push({
        name: item.name,
        title: item.title,
        isDesc: false,
      });
    },
    moveToAvailableColumns(item) {
      if (!item) {
        return;
      }
      const index = this.selectedColumns.map((s) => s.name).indexOf(item.name);
      this.selectedColumns.splice(index, 1);
    },
    changeDirection(item) {
      item.isDesc = item.isDesc === false ? true : false;
    },
  },
};
</script>
